import { Modal, Group } from "@mantine/core";
import { CDN_URL } from "../../../constant";

const VideoSpotPopUp = ({
	isInfoVideoSpotOpen,
	setIsInfoVideoSpotOpen,
	infoVideoSpotDetails,
}) => {
	return (
		<>
			<Modal
				centered
				size="lg"
				opened={isInfoVideoSpotOpen}
				onClose={() => setIsInfoVideoSpotOpen(false)}
				title={infoVideoSpotDetails.name}
				styles={{
					modal: { backgroundColor: "Transparent" },
					title: { color: "#ffffff", fontWeight: "700" },
					body: { maxHeight: "80%" },
				}}
			>
				<Group position="center">
					<video controls width="100%">
						<source
							src={CDN_URL + infoVideoSpotDetails.url}
							type="video/mp4"
						/>
						Your browser does not support the video tag.
					</video>
				</Group>
			</Modal>
		</>
	);
};

export default VideoSpotPopUp;
